import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  DataGrid,
  Table,
} from '../../../components/index';
import {
  getObject,
  vinculo,
  sexo,
  estadoCivil,
  capacidade,
} from '../../../utils/listsSelect';
import DependenteCessacao from './DependenteCessacao';
import { requestMotivosCessacaoDependente } from '../../../utils/requests';

class DependentesCessacao extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

    getInitialState = () => ({
      acaoModal: null,
      showModal: false,
      errosDependenteSelecionado: null,
      exigenciasDependentes: null,
      dependenteSelecionado: null,
      listaDependentesCessando: [],
    })

    handleModal = () => {
      this.setState({ showModal: !this.state.showModal, acaoModal: 'cessar-dependente' });
    }

    addVinculoLabel = (vinculoSelecionado) => {
      const obj = getObject(vinculo, vinculoSelecionado);
      let valorlabel = null;
      if (obj) {
        valorlabel = obj.label;
      }
      return valorlabel;
    }

    addSexoLabel = (sexoSelecionado) => {
      const obj = getObject(sexo, sexoSelecionado);
      let valorlabel = null;
      if (obj) {
        valorlabel = obj.label;
      }
      return valorlabel;
    }

    addEstadoCivilLabel = (estadoCivilSelecionado) => {
      const obj = getObject(estadoCivil, estadoCivilSelecionado);
      let valorlabel = null;
      if (obj) {
        valorlabel = obj.label;
      }
      return valorlabel;
    }

    addCapacidadeLabel = (capacidadeSelecionada) => {
      const obj = getObject(capacidade, capacidadeSelecionada);
      let valorlabel = null;
      if (obj) {
        valorlabel = obj.label;
      }
      return valorlabel;
    }

    buscaMotivosCessacaoDependente = (tipo, tipoMotivo) => {
      requestMotivosCessacaoDependente(this.handleErrorBusca, tipo, tipoMotivo);
    }

    handleErrorBusca = () => {
    }
    /**
     * Determina a acao que estara disponivel para cada dependente:
     * - Usuario esta criando um requerimento ou cumprindo exigencias, dependente pode ser alterado;
     * - Usuario esta emitindo parecer, dependente pode ser alterado se tiver a Capacidade adequada;
     * - Em outras situacoes, o dependente pode apenas ser visualizado.
     */
    createActionColumn = (indice, dependente) => (
      <React.Fragment>
        <Button
          className={dependente.cessando ? 'dtp-inverse' : ''}
          hint={dependente.dataCessacao ? 'Visualizar dependente' : 'Cessar dependente'}
          icon={dependente.dataCessacao ? 'ico-user-magnifier' : 'ico-pencil'}
          mini
          onClick={() => this.editDependente(dependente)}
        />
      </React.Fragment>
    );

    /**
     * Altera um dependente da lista
     */
    editDependente = (dependenteSelecionado) => {
      const tipoMotivo = 3;
      const aplicacao = 3;
      this.setState(this.buscaMotivosCessacaoDependente(aplicacao, tipoMotivo));
      this.setState({
        cell: dependenteSelecionado.acoes,
        dependenteSelecionado,
      }, this.handleModal);
    }

  options = {
    noDataText: 'Nenhum dependente cadastrado',
    hideSizePerPage: true,
    sizePerPage: 10,
  };

  montaDependentesTableHeader = () => {
    const tableHeader = [{
      id: 'cpf',
      label: 'CPF',
    }, {
      id: 'nome',
      label: 'Nome',
    }, {
      id: 'sexo',
      label: 'Sexo',
      dataFormat: this.addSexoLabel,
    }, {
      id: 'estadoCivil',
      label: 'Estado Civil',
      dataFormat: this.addEstadoCivilLabel,
    }, {
      id: 'capacidade',
      label: 'Capacidade',
      dataFormat: this.addCapacidadeLabel,
    }, {
      id: 'vinculo',
      label: 'Vínculo',
      dataFormat: this.addVinculoLabel,
    }, {
      id: 'dataNascimento',
      label: 'Data de Nascimento',
    }, {
      id: 'dataCessacao',
      label: 'Data de Cessação',
    },
    ];
    tableHeader.push({
      id: 'acao',
      label: 'Ação',
      dataFormat: this.createActionColumn,
    });
    return tableHeader;
  }

  /**
  * Remove a selecao do dependente
  */
  resetDependenteSelecionado = () => {
    this.setState({
      dependenteSelecionado: null,
      acaoModal: null,
    });
  }

  cancelarCessacaoDependente = (dependente) => {
    const { dependentes } = { ...this.props };
    const { listaDependentesCessando } = { ...this.state };

    const indexDepCancelando =
    listaDependentesCessando.findIndex(dep => (dep.nome === dependente.nome));

    if (indexDepCancelando !== -1) {
      if (dependentes[this.state.cell].dataCessacao === dependente.dataCessacao ||
        dependente.dataCessacao === '') {
        dependentes[this.state.cell] = dependente;
        dependentes[this.state.cell].ordemCessacao = 0;
      }
    }

    if (listaDependentesCessando.length > 0 && indexDepCancelando !== -1) {
      this.props.handleChangeDependentes({
        value: dependentes,
        isValid: dependentes.length > 0,
        listaDependentesCessando,
      });
    }
  }

  cessarDependente = (dependente) => {
    const { dependentes } = { ...this.props };
    const { listaDependentesCessando } = { ...this.state };

    dependentes[this.state.cell] = dependente;

    if (listaDependentesCessando.length === 0) {
      // primeiro item da colecao
      dependentes[this.state.cell].ordemCessacao = 1;
      listaDependentesCessando.push(dependentes[this.state.cell]);
    } else {
      const objNome = dependentes[this.state.cell].nome;
      const indexDep = listaDependentesCessando.findIndex(dep => (dep.nome === objNome));
      if (indexDep === -1) {
        dependentes[this.state.cell].ordemCessacao = listaDependentesCessando.length + 1;
        listaDependentesCessando.push(dependentes[this.state.cell]);
      } else {
        const ordemAntiga = listaDependentesCessando[indexDep].ordemCessacao;
        listaDependentesCessando.splice(indexDep, 1);
        dependentes[this.state.cell].ordemCessacao =
        listaDependentesCessando.length + (ordemAntiga + 1);
        listaDependentesCessando.push(dependentes[this.state.cell]);
      }
    }

    this.props.handleChangeDependentes({
      value: dependentes,
      isValid: dependentes.length > 0,
      listaDependentesCessando,
    });
  }

  render() {
    const listaDependentesIndexada = this.props.dependentes.map((item, i) => {
      const itemIndexado = item;
      itemIndexado.acoes = i;
      if (!itemIndexado.foiCessado && (itemIndexado.dataCessacao && itemIndexado.motivoCessacao)) {
        itemIndexado.cessando = true;
      }
      return itemIndexado;
    });
    const modalDependente = this.state.showModal ?
      (<DependenteCessacao
        acaoModal={this.state.acaoModal}
        acao={this.props.acao}
        dependente={this.state.dependenteSelecionado}
        motivosCessacaoDependente={this.props.motivosCessacaoDependente}
        onHide={this.handleModal}
        resetDependente={this.resetDependenteSelecionado}
        showModal
        cessarDependente={this.cessarDependente}
        cancelarCessacaoDependente={this.cancelarCessacaoDependente}
      />
      ) : null;
    return (
      <DataGrid title="Dependentes" icon="ico-users" >
        <Table
          bordered
          data={listaDependentesIndexada}
          options={this.options}
          listaTableHeader={this.montaDependentesTableHeader()}
          pagination
          scrollTop="Top"
        />
        {modalDependente}
      </DataGrid>
    );
  }
}

DependentesCessacao.propTypes = {
  acao: PropTypes.string.isRequired,
  handleChangeDependentes: PropTypes.func.isRequired,
  dependentes: PropTypes.arrayOf(PropTypes.shape({
    codigo: PropTypes.number,
    cpfDependente: PropTypes.string,
    nome: PropTypes.string,
    nomeMae: PropTypes.string,
    dataNascimento: PropTypes.date,
    sexo: PropTypes.number,
    estadoCivil: PropTypes.number,
    vinculo: PropTypes.number,
    capacidade: PropTypes.number,
    motivoInclusao: PropTypes.number,
    invalidezDeAcordoMedico: PropTypes.number,
    dataCessacao: PropTypes.date,
  })).isRequired,
  motivosCessacaoDependente: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
      tipoRequerimento: PropTypes.string,
    }),
  }),
};

DependentesCessacao.defaultProps = {
  match: null,
  motivosCessacaoDependente: null,
};

const mapStateToProps = state =>
  ({
    motivosCessacaoDependente: state.base.motivosCessacaoDependente,
  });
export default connect(mapStateToProps)(DependentesCessacao);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Cessacao/DependentesCessacao.jsx